module.exports = __webpack_public_path__ + "static/media/starters.3a205adf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/starters.svg
// module id = 70
// module chunks = 0